// import { isNull } from 'util'
import localStore from '../../utils/localstore_polyfill'

/**
 * @type {import("vuex").Module<{historys: string[]}, {historys:string[]}>}
 */
const historyStore = {
  state: {
    /**
     * @type {string[]}
     */
    historys: []
  },
  mutations: {
    setHistory (state, history) {
      if (history) {
        state.historys = history
      }
    }
  },
  actions: {
    setHistory (context, history) {
      context.commit('setHistory', history)
      localStore.setItem('search-history', JSON.stringify(history))
    },
    addHistory (context, his) {
      let my = Array.from(context.state.historys)
      let index = my.indexOf(his)
      if (index >= 0) {
        my.splice(index, 1)
      }
      if(his){
        my.push(his)
      }
      context.commit('setHistory', my)
      localStore.setItem('search-history', JSON.stringify(my))
      console.log(context.state.historys)
    },
    clearHistory (context) {
      context.commit('setHistory', [])
      localStore.removeItem('search-history')
    },
    readHistory (context) {
      let strHistory = localStore.getItem('search-history')
      context.commit('setHistory', JSON.parse(strHistory))
    }
  }
}

export default historyStore
